import Big from 'big.js';

Big.RM = 0;
const BIG_0 = new Big(0);
const BIG_1 = new Big(1);

const formatNumber = (s: string) => (s ? s.replace(/\B(?=(?=\d*\.)(\d{3})+(?!\d))/g, ',') : '');

export const formatBig = (b?: Big | null): string => b?.toString() ?? '';
export const formatBalance = formatBig;

// deprecated
export const formatCurrency = (s?: string | null, currency?: string): string =>
  s ? formatNumber(new Big(s).toFixed(2)) + (currency ? ` ${currency}` : '') : '';

export const formatBigPercent = (amount?: Big | null, round?: number | undefined): string => {
  if (!amount) return '';
  const percentage = amount.mul(100);
  const rounded = round ? percentage.round(round) : percentage;
  return `${rounded.toString()}%`;
};
export const formatStrPercent = (s?: string | null): string => (s ? formatBigPercent(new Big(s)) : '');

export const formatCardNumber = (s?: string) =>
  s ? `${s.slice(0, 4)} ____ ____ ${s.slice(-4)}`.replaceAll('_', '*') : '';

export const formatCardNumberLast4 = (s?: string) => (s ? `${s.slice(-4)}` : '');

export const formatSatoshiFromBTC = (amountBTC?: Big | null, displayDecimals = false) => {
  if (!amountBTC) return amountBTC;
  if (amountBTC.eq(BIG_0)) return 'zero';
  const satoshi = amountBTC.mul(100_000_000);
  if (BIG_1.eq(satoshi)) return '1 satoshi';
  const rounded = satoshi.round(6);
  if (displayDecimals && BIG_0.eq(rounded)) return `less than 0.000001 satoshis`;
  if (displayDecimals)
    return `${formatNumber(rounded.round(0).eq(rounded) ? rounded.toFixed(2) : rounded.toFixed())} satoshis`;
  if (satoshi.gt(BIG_1)) return `${formatNumber(rounded.toFixed(0))} satoshis`;
  if (satoshi.lt(BIG_1)) return 'less than 1 satoshi';
};

export const formatAmount = (
  amount: Big | string | null | undefined,
  decimalPrecisionDisplay = 2
): string => {
  if (amount === null || amount === undefined || amount === '') return '';
  const rounded = Big(amount).round(decimalPrecisionDisplay);
  const decimalsLength = rounded.toFixed().split('.')[1]?.length ?? 0;
  const fixed = decimalsLength < 2 ? rounded.toFixed(2) : rounded.toFixed();
  const formatted = formatNumber(fixed);
  return decimalPrecisionDisplay === 0 ? formatted.replace('.00', '') : formatted;
};

export const formatProductPrice = (price: string, decimalPrecisionDisplay = 2, fee = '0', quantity = 1) =>
  formatAmount(
    Big(price)
      .mul(Big(quantity))
      .plus(Big(price).mul(Big(quantity)).mul(Big(fee))),
    decimalPrecisionDisplay
  );

export const formatProductFee = (price: string, decimalPrecisionDisplay = 2, fee: string, quantity = 1) =>
  formatAmount(Big(price).mul(Big(quantity)).mul(Big(fee)), decimalPrecisionDisplay);

export const formatPrice = (price: string, decimalPrecisionDisplay = 2, quantity = 1) =>
  formatProductPrice(price, decimalPrecisionDisplay, '0', quantity);

export const formatAsset = (
  amount?: string,
  asset?: string,
  assets?: Record<string, { decimalPrecisionDisplay: number }>
) => {
  try {
    return amount
      ? formatAmount(Big(amount), asset && assets ? assets[asset.toUpperCase()]?.decimalPrecisionDisplay : 2)
      : '';
  } catch (e) {
    console.error('formatAsset: cannot format amount = ', amount, e instanceof Error && e.message);
    throw e;
  }
};

export const truncate = (amount: Big | string | null | undefined, decimals: number) =>
  amount ? Big(amount).toFixed(decimals, Big.roundDown) : '';
